import { computed, Injectable, inject, signal, Signal, WritableSignal } from "@angular/core";
import { PaymentMethodService } from "../../../settings/billing/payment-method/payment-method.service";
import { LocalStorageService } from "../../local-storage.service";
import { LOCALSTORAGE_KEYS } from "../../constants/databases";
import { Session } from "../../types/session.type";
import { FormBuilder, Validators } from "@angular/forms";


@Injectable({ providedIn: 'root' })
export class ExplorerPaymentMethodService {

    private paymentMethodService = inject(PaymentMethodService);
    private localStorageService = inject(LocalStorageService);
    private fb = inject(FormBuilder);

    private states: WritableSignal<{ id: string, name: string }[]> = signal([]);
    getStates: Signal<{ id: string, name: string }[]> = computed(() => this.states());

    private deliveryDayText: WritableSignal<string> = signal('');
    getDeliveryDayText: Signal<string> = computed(() => this.deliveryDayText());

    private title: WritableSignal<string> = signal('');
    getTitle: Signal<string> = computed(() => this.title());
    setTitle = (title: 'subscription' | 'checkout') => { this.title.set(title === 'subscription' ? 'Confirm Your Subscription' : 'Confirm Your Checkout'); }

    /** Payment method form with billing information */
    paymentForm = this.fb.group({
        cardNumber: ['', Validators.required],
        exp: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])\/(\d{4})$/)]],
        cvc: ['', Validators.required],
        billingName: ['', Validators.required],
        billingAddress1: ['', Validators.required],
        billingAddress2: [''],
        billingCity: ['', Validators.required],
        billingState: ['', Validators.required],
        billingZip: ['', Validators.required],
        terms: [false, Validators.requiredTrue]
    });

    constructor() {
        this.paymentMethodService.getStates().subscribe(states => this.states.set(states));
        this.setupDeliveryDayText();
    }

    private setupDeliveryDayText() {
        const sessionStored = this.localStorageService.get(LOCALSTORAGE_KEYS.SESSION) as Session;
        this.deliveryDayText.set(sessionStored.deliveryInfo?.deliveryDay || 'your delivery day');
    }

}